export enum SidebarModuleFilter {
  Bakers = 'BAKERS',
  Wheat = 'WHEAT',
  All = 'All',
}

export const isModuleHidden = (
  showBakerModule: boolean,
  module?: SidebarModuleFilter
) => {
  if (!module || module === SidebarModuleFilter.All) return false
  if (showBakerModule && module === SidebarModuleFilter.Wheat) return true
  if (!showBakerModule && module === SidebarModuleFilter.Bakers) return true
  return false
}
